export default "__VITE_ASSET__Bh$iJi3U__"